/** The eyebrow above a section of the goal details pane: This week, Cadences, Repeats, Next up, Recent. */
const SectionLabel = ({ children }: { children: React.ReactNode }) => (
    <span className="text-label-md uppercase tracking-[0.02em] text-muted-foreground">{children}</span>
)

export default SectionLabel
